export
const name: string = "ShadowMapVariance";

export
const preproc: string = `
    //#version 100

    //precision mediump float;
`;

export
const declaration: string = `
    attribute vec3 a_position;
    attribute vec3 a_normal;
    attribute float a_visibility;
    attribute float a_manipulation;

    uniform mat4 u_lightProjMatrix;
    uniform mat4 u_lightViewMatrix;
    uniform mat4 u_manipulator;
`;

export
const varyings: string = `
    varying vec3 v_worldNormal;
    varying vec4 v_worldPosition;
    varying float v_visible;
`;

export
const implementation: string = `
    void main() {

        v_visible = a_visibility;
        v_worldNormal = a_normal;

        vec4 position = vec4(a_position, 1.0) * a_visibility;
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif

        v_worldPosition = position;

    #ifdef CLIPPING_PLANE
        setVaryingsForCPlane(position);
    #endif

        gl_Position = u_lightProjMatrix * u_lightViewMatrix * position;

    #ifdef LOGDEPTH
            setVaryingsForLogarithmicDepthBuffer();
    #endif
    }
`;
